import { inject } from '@angular/core';
import type {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot,
} from '@angular/router';
import { Location } from '@freelancer/location';
import { TrackingConsentBannerService } from './tracking-consent-banner.service';

export const TrackingConsentOverridesGuard = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): ReturnType<CanActivateFn> => {
  const trackingConsentBannerService = inject(TrackingConsentBannerService);
  const location = inject(Location);

  const { searchParams } = new URL(location.href);

  if (
    searchParams.has('disable_tracking_consent_banner') &&
    searchParams.get('disable_tracking_consent_banner') !== 'false'
  ) {
    trackingConsentBannerService.setIsTrackingConsentBannerDisabled(true);
  }

  return true;
};
